import(/* webpackMode: "eager" */ "/app/apps/plus/src/app/global-error.tsx");
